<template>
  <div>
    <Dashboard />
    <section id="content">
      <div class="container">
        <ListHeaderTool
          @dateFilter="dateFilter"
          @filterType="filterType"
        ></ListHeaderTool>
      </div>
      <div class="container" id="content-item">
        <ListHeader />
        <FetchData
          :transactions="transactions"
          @openModal="openModal"
          @openBill="openBill"
        ></FetchData>
        <Loader :class="{ marinTop: mTop }" v-if="loader" />
        <Pagination
          :totalPage="totalPage"
          :selectTransactionType="selectTransactionType"
          :pageIndex="pageIndex"
          @fetchData="fetchData"
        ></Pagination>
      </div>
      <transition name="fade">
        <Modal
          :show="showModal"
          :coin="coin"
          :itemData="modalData"
          @hideModal="closeModal"
          :headerData="headerData"
        ></Modal>
      </transition>
      <transition name="fade">
        <TransferModal
          :show="showTransferModal"
          :coin="coin"
          :itemData="modalData"
          @hideTransferModal="closeTransferModal"
          :headerData="headerData"
          :invPkId="invPkId"
        ></TransferModal>
      </transition>
      <transition name="fade">
        <ServiceCommissionModal
          :show="showServiceCommissionModal"
          :itemData="modalData"
          @hideServiceCommissionModal="closeServiceCommissionModal"
          :headerData="headerData"
          :invPkId="invPkId"
        ></ServiceCommissionModal>
      </transition>
      <transition name="fade">
        <BillModal
          :show="showBill"
          :itemData="billData"
          :billMessage="billMessage"
          @hideBillModal="closeBillModal"
          :invPkId="invPkId"
        ></BillModal>
      </transition>
      <transition name="fade">
        <Error
          :errorMessage="errorMessage"
          v-if="errorModal"
          @hideErrorMessage="hideErrorMessage"
        ></Error>
      </transition>
    </section>
  </div>
</template>

<script>
import FetchData from "./FetchData";
import EventBus from "@/EventBus.js";
import ListHeader from "./ListHeader";
import Error from "@/views/plugin/error";
import Loader from "@/views/plugin/loader";
import ListHeaderTool from "./ListHeaderTool";
import Dashboard from "@/views/layout/Dashboard";
import Modal from "@/components/transaction/Modal";
import Pagination from "@/views/plugin/pagination";
import BillModal from "@/components/transaction/BillModal";
import { TransactionChild } from "@/mixins/TransactionChild";
import TransferModal from "@/components/transaction/TransferModal";
import ServiceCommissionModal from "@/components/transaction/ServiceCommisionModal";

export default {
  data() {
    return {
      modalData: [],
      billData: null,
      billMessage: "",
      headerData: {},
      invPkId: "",
      transactions: {},
      pageIndex: "",
      totalPage: "",
      errorMessage: "",
      transactionType: "",
      selectTransactionType: "All",
      newStartDate: "",
      newEndDate: "",
      mTop: false,
      showModal: false,
      showTransferModal: false,
      showServiceCommissionModal: false,
      showBill: false,
      loader: true,
      errorModal: false,
      coin: true,
    };
  },
  mixins: [TransactionChild],
  methods: {
    // hide close detail modal
    closeModal() {
      this.showModal = false;
    },
    // hide close detail transfer modal
    closeTransferModal() {
      this.showTransferModal = false;
    },
    closeBillModal() {
      this.showBill = false;
    },
    closeServiceCommissionModal() {
      this.showServiceCommissionModal = false;
    },
    // hide error message
    hideErrorMessage() {
      (this.errorMessage = ""), (this.errorModal = false);
    },
    //scroll top
    scrollToTop() {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    },
    //hide menu mobile when page loaded
    hideMenu() {
      EventBus.$emit("MOBILE_MENU_HIDE");
    },
    RedirectLogin() {
      EventBus.$emit("GLOBAL_ERROR", "error");
    },
  },
  created() {
    this.fetchData();
    this.hideMenu();
  },
  components: {
    Modal,
    Error,
    Loader,
    Dashboard,
    FetchData,
    BillModal,
    ListHeader,
    Pagination,
    TransferModal,
    ListHeaderTool,
    ServiceCommissionModal,
  },
};
</script>

<style>
.marinTop {
  margin-top: 10%;
}
</style>
